import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  listObjState,
  userObjState,
  pagesObjState,
  editModeState,
  editObjState,
  copiedMarksState,
} from "../recoil-atom"

import { authService, dbService } from "../fbase"
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  GithubAuthProvider,
  signInWithPopup,
} from "firebase/auth"
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  doc,
  setDoc,
  getDoc,
  addDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore"

import Search from "../components/Search"
import LinkEdit from "../components/LinkEdit"
import ListPage from "../components/ListPage"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
  ListPages,
  PageMarks,
  GroupMarks,
  Mark,
  Icon,
} from "../styled-components-openmark"
// import styled from "styled-components"

import { FileList, DownloadCloud, UploadCloud } from "@styled-icons/remix-fill"
import {
  TableEdit,
  CheckboxChecked,
  CircleEdit,
} from "@styled-icons/fluentui-system-filled"

const List = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [listObj, setListObj] = useRecoilState(listObjState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const [pagesObj, setPagesObj] = useRecoilState(pagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)
  const [copiedMarks, setCopiedMarks] = useRecoilState(copiedMarksState)

  const [init, setInit] = useState(false)

  useEffect(() => {
    async function fetchList() {
      const listLocalStorage = await window.localStorage.getItem("list")
      // console.log(listLocalStorage)
      if (listLocalStorage) {
        setListObj(JSON.parse(listLocalStorage))
      } else {
        // console.log("firebase")
        // Get Pages
        const docPagesRef = collection(dbService, "pages")
        const querySnapShot = await getDocs(
          query(
            docPagesRef,
            where("category", "==", "linkpage"),
            orderBy("updatedAt", "desc"),
            limit(10)
          )
        )

        const newListObj = {}
        querySnapShot.forEach((doc) => {
          newListObj[doc.id] = doc.data()
        })

        setListObj(newListObj)
        window.localStorage.setItem("list", JSON.stringify(newListObj))
      }
    }
    fetchList()
    setInit(true)
  }, [])

  return (
    <>
      {editObj !== null ? <LinkEdit /> : null}

      <div className="pages">
        {listObj !== null
          ? Object.entries(listObj).map(([key, value], index) => (
              <ListPage pageId={key} key={index} />
            ))
          : null}
      </div>
      <style jsx>{`
        .pages {
          width: ${size.appWidth}px;
          margin: 10px auto 20px auto;
          border-radius: 20px;
          padding: 10px 0;
          ${size.appPage === 2
            ? "padding: 10px 20px 20px 20px;"
            : "padding: 5px 0 10px 0;"}
          background-color: ${theme.b1};
          display: grid;
          grid-template-columns: repeat(${size.appPage}, 1fr);
          ${size.appPage === 2 ? "gap: 20px;" : "gap: 5px;"}
          box-shadow: 1px 1px 3px 1px ${theme.b2};
        }
        .icon {
          ${size.appPage == 2 ? "grid-column: 1 / 3" : null}
        }
      `}</style>
    </>
  )
}

export default List
